import size from 'lodash/size';
import compact from 'lodash/compact';
import has from 'lodash/has';

export function extendBlockProps(originalBlockProps, attributes, isSaving) {
  const { biteClass, biteMotionClass, biteMeta } = attributes;

  let extendedBlockProps = originalBlockProps;

  if (size(biteClass) || size(biteMotionClass) || size(biteMeta?.interaction)) {
    const biteClasses = [
      biteClass,
      biteMotionClass,
      originalBlockProps.className,
    ];
    let newClass = compact(biteClasses).join(' ');
    let interactionProps = {};

    if (
      has(biteMeta, 'interaction.actionType') &&
      size(biteMeta.interaction.actionType)
    ) {
      interactionProps['data-b_action_type'] = biteMeta.interaction.actionType;
    }
    if (
      has(biteMeta, 'interaction.actionRef') &&
      size(biteMeta.interaction.actionRef)
    ) {
      interactionProps['data-b_action_ref'] = biteMeta.interaction.actionRef;
    }

    extendedBlockProps = {
      ...originalBlockProps,
      ...interactionProps,
      className: newClass,
    };
  }
  return extendedBlockProps;
}
